define("shared/components/shared/credentials/docs-for-new-page", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @closable={{false}} @close={{action @close}} ...attributes as |modal|>
    <modal.card @closeIcon={{false}} @portrait={{true}}>
      <modal.card-header @title={{t "credentials.docs.title"}} />
      <modal.card-body class="u--p__t__0" {{did-insert (fn this.updateNameOfPage null)}}>
        <div class="u--row">
          <div class="u--col__4">
            <div class="o--card">
              <img class="o--media" src="/assets/images/img--credentials--permissionsRequired.gif" />
            </div>
          </div>
          <div class="u--col__7 u--col__push--1">
            <b>{{t "credentials.docs.header"}}</b>
            <ol class="u--p__l">
              <li>{{html-safe (t "credentials.docs.step_1")}}</li>
              <li>{{html-safe (t "credentials.docs.step_2")}}</li>
              <li>{{html-safe (t "credentials.docs.step_3")}}</li>
            </ol>
            <p>
              <a class="u--block u--m__b__xs" {{on "click" (toggle-action "showHelpDropdown" this)}}>
                {{t "credentials.docs.dont_see_page"}}
              </a>
              <span class="u--text--light {{if this.showHelpDropdown 'u--fadeIn' 'u--hide'}}">
                {{t "credentials.docs.answer"}}
              </span>
            </p>
            <p>{{html-safe (t "credentials.docs.which_fb_page" nickname=this.socialProfile.nickname)}}</p>
            <div class="o--formWrapper">
              <Input
                @type="text"
                @value={{this.state.nameOfPage}}
                class="o--form__input"
                id="pageName"
                placeholder={{t "credentials.docs.placeholder"}}
              />
            </div>
          </div>
        </div>
      </modal.card-body>
      <modal.card-footer>
        <div class="o--btnGroup u--float--left">
          <Shared::Link
            @href="https://www.facebook.com/help/1148909221857370"
            @text={{t "credentials.docs.cant_connect"}}
            class="o--btn"
          />
        </div>
        <div class="o--btnGroup u--float--right">
          <Shared::Ui::Button
            @isDisabled={{not this.state.nameOfPage}}
            @promise={{task @revokePermissions}}
            @runningText={{t "credentials.docs.check_fb_page_load"}}
            @text={{t "credentials.docs.check_fb_page"}}
            @variant="primary"
          />
        </div>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "XIlmOvDl",
    "block": "[[[8,[39,0],[[17,1]],[[\"@closable\",\"@close\"],[false,[28,[37,1],[[30,0],[30,2]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,3,[\"card\"]],null,[[\"@closeIcon\",\"@portrait\"],[false,true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"card-header\"]],null,[[\"@title\"],[[28,[37,2],[\"credentials.docs.title\"],null]]],null],[1,\"\\n    \"],[8,[30,3,[\"card-body\"]],[[24,0,\"u--p__t__0\"],[4,[38,3],[[28,[37,4],[[30,0,[\"updateNameOfPage\"]],null],null]],null]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--card\"],[12],[1,\"\\n            \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--credentials--permissionsRequired.gif\"],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--col__7 u--col__push--1\"],[12],[1,\"\\n          \"],[10,\"b\"],[12],[1,[28,[35,2],[\"credentials.docs.header\"],null]],[13],[1,\"\\n          \"],[10,\"ol\"],[14,0,\"u--p__l\"],[12],[1,\"\\n            \"],[10,\"li\"],[12],[1,[28,[35,5],[[28,[37,2],[\"credentials.docs.step_1\"],null]],null]],[13],[1,\"\\n            \"],[10,\"li\"],[12],[1,[28,[35,5],[[28,[37,2],[\"credentials.docs.step_2\"],null]],null]],[13],[1,\"\\n            \"],[10,\"li\"],[12],[1,[28,[35,5],[[28,[37,2],[\"credentials.docs.step_3\"],null]],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[12],[1,\"\\n            \"],[11,3],[24,0,\"u--block u--m__b__xs\"],[4,[38,6],[\"click\",[28,[37,7],[\"showHelpDropdown\",[30,0]],null]],null],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"credentials.docs.dont_see_page\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[15,0,[29,[\"u--text--light \",[52,[30,0,[\"showHelpDropdown\"]],\"u--fadeIn\",\"u--hide\"]]]],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"credentials.docs.answer\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[12],[1,[28,[35,5],[[28,[37,2],[\"credentials.docs.which_fb_page\"],[[\"nickname\"],[[30,0,[\"socialProfile\",\"nickname\"]]]]]],null]],[13],[1,\"\\n          \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n            \"],[8,[39,9],[[24,0,\"o--form__input\"],[24,1,\"pageName\"],[16,\"placeholder\",[28,[37,2],[\"credentials.docs.placeholder\"],null]]],[[\"@type\",\"@value\"],[\"text\",[30,0,[\"state\",\"nameOfPage\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,3,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"o--btnGroup u--float--left\"],[12],[1,\"\\n        \"],[8,[39,10],[[24,0,\"o--btn\"]],[[\"@href\",\"@text\"],[\"https://www.facebook.com/help/1148909221857370\",[28,[37,2],[\"credentials.docs.cant_connect\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--btnGroup u--float--right\"],[12],[1,\"\\n        \"],[8,[39,11],null,[[\"@isDisabled\",\"@promise\",\"@runningText\",\"@text\",\"@variant\"],[[28,[37,12],[[30,0,[\"state\",\"nameOfPage\"]]],null],[28,[37,13],[[30,4]],null],[28,[37,2],[\"credentials.docs.check_fb_page_load\"],null],[28,[37,2],[\"credentials.docs.check_fb_page\"],null],\"primary\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[3]]]]]],[\"&attrs\",\"@close\",\"modal\",\"@revokePermissions\"],false,[\"shared/modal\",\"action\",\"t\",\"did-insert\",\"fn\",\"html-safe\",\"on\",\"toggle-action\",\"if\",\"input\",\"shared/link\",\"shared/ui/button\",\"not\",\"task\"]]",
    "moduleName": "shared/components/shared/credentials/docs-for-new-page.hbs",
    "isStrictMode": false
  });

  let DocsForNewPageComponent = (_class = class DocsForNewPageComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "credentials", _descriptor, this);
    }

    get socialProfile() {
      return this.credentials.socialProfile;
    }

    get state() {
      return this.credentials.state;
    }

    updateNameOfPage(payload) {
      this.credentials.updateNameOfPage(payload);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "credentials", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "updateNameOfPage", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateNameOfPage"), _class.prototype)), _class);
  _exports.default = DocsForNewPageComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, DocsForNewPageComponent);
});